module.exports = __webpack_public_path__ + "img/down-arrow-blue.c62fe19e.svg";